const forFacilitiesResources = {
    title: 'For Facilities',
};
export default forFacilitiesResources;